import { defineRecipe } from "@chakra-ui/react/styled-system";

// Map Chakra's stock size variants (xs - 4xl) onto our `textStyles.heading.*`
// so existing `<Heading size="xl">` call sites and the unstyled default both
// pick up the type scale defined in `theme/index.ts` instead of Chakra's
// generic one. Call sites that pass `textStyle="heading.X"` directly keep
// working — explicit prop wins over recipe variant.
export default defineRecipe({
  variants: {
    size: {
      xs: { textStyle: "caption" },
      sm: { textStyle: "label" },
      md: { textStyle: "heading.4" },
      lg: { textStyle: "heading.3" },
      xl: { textStyle: "heading.2" },
      "2xl": { textStyle: "heading.1" },
      "3xl": { textStyle: "display" },
      "4xl": { textStyle: "display" },
    },
  },
  defaultVariants: {
    size: "xl",
  },
});
